import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="relative bg-[#0B1436] py-14" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
        <div className="max-w-sm">
          <Logo variant="light" />
          <p className="mt-5 font-body text-sm leading-relaxed text-white/55">
            Fondazione Semi d&rsquo;Impresa &ldquo;Luca Delle Donne&rdquo; Impresa Sociale ETS.
          </p>
        </div>

        <div className="flex flex-col gap-8 sm:flex-row sm:gap-16">
          <div>
            <p className="font-body text-xs uppercase tracking-overline text-[#C9A227]">
              Naviga
            </p>
            <ul className="mt-4 space-y-3">
              {[
                { href: "#problema", label: "Il problema" },
                { href: "#soluzione", label: "La soluzione" },
                { href: "#formula", label: "La formula" },
                { href: "#iscrizione", label: "Iscriviti" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="font-body text-sm text-white/70 transition-colors hover:text-[#C9A227]"
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-body text-xs uppercase tracking-overline text-[#C9A227]">
              Contatti
            </p>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href="mailto:segreteria@fondazionesemidimpresa.it"
                  className="font-body text-sm text-white/70 transition-colors hover:text-[#C9A227]"
                  data-testid="footer-email"
                >
                  segreteria@fondazionesemidimpresa.it
                </a>
              </li>
              <li>
                <a
                  href="tel:+390832393823"
                  className="font-body text-sm text-white/70 transition-colors hover:text-[#C9A227]"
                  data-testid="footer-phone"
                >
                  0832 / 393823
                </a>
              </li>
              <li>
                <span className="font-body text-sm text-white/70">
                  Secolario &mdash; Masseria del Viverbene &middot; Palmariggi (Le)
                </span>
              </li>
              <li>
                <a
                  href="#privacy"
                  className="font-body text-sm text-white/70 transition-colors hover:text-[#C9A227]"
                  data-testid="footer-privacy"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-body text-xs text-white/40">
          © {new Date().getFullYear()} Fondazione Semi d&rsquo;Impresa. Tutti i diritti riservati.
        </p>
      </div>
    </div>
  </footer>
);
